/* eslint-disable @typescript-eslint/naming-convention */
import React, {useEffect, useRef, useState} from 'react';
// import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.min.css';
import './index.css';
import {
  ApplicationScenarioInfoList,
  ProductAbilityInfoCardList,
  CurrentCardListLeftPosition,
  //  PartnerLogoList,
} from '../../config/productAbilityCardList';
// import qcodeImage from '../../common/img/icon_qcode.png';
import {report} from '../../util/report';
// import yuewenImage from '../../common/img/business-partner_yuewen.png';
// import tencentQcloudImage from '../../common/img/business-partner_qcloud.png';
// import uaLogoImage from '../../common/img/business-partner_ua.png';
import animationPerson from '../../common/img/icon_translate_animation_person.png';

import androidQrCode from '../../common/img/bottom-qr-code/android.png';
import iosQrCode from '../../common/img/bottom-qr-code/ios.png';
import wxProgramQrCode from '../../common/img/bottom-qr-code/wx.png';

// @ts-ignore
import translateAnimationVideo from '../../common/video/translate_animation.mp4';
import {Link} from "react-router-dom";

const qrcodeList = [
  { id: 1, src: androidQrCode, text: '下载Android版翻译君' },
  { id: 2, src: iosQrCode, text: '下载ios/iPadOS版翻译君' },
  { id: 3, src: wxProgramQrCode, text: '腾讯翻译君小程序' },
];

export default function ProductIntroduce() {
  const subProductListRef = useRef<HTMLUListElement>(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  useEffect(() => {
    updateSubProductList();
    const handleResize = () => {
      updateSubProductList();
    };

    window.addEventListener('resize', handleResize);

    const handleScrollResize = () => {
      const left = subProductListRef.current?.scrollLeft || 0;
      CurrentCardListLeftPosition.map((item, index) => {
        if (left > item && left < CurrentCardListLeftPosition[index + 1]) {
          setCurrentCardIndex(index);
        }
      });
    };

    subProductListRef.current?.addEventListener('scroll', handleScrollResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      subProductListRef.current && subProductListRef.current.removeEventListener('scroll', handleScrollResize);
    };
  }, []);

  const updateSubProductList = () => {
    const padding = (window.innerWidth - 1200) / 2;
    if (padding && !isNaN(padding) && subProductListRef.current) {
      subProductListRef.current.style.padding = `10px ${(padding)}px 50px`;
    }
  };

  // const navigateToPartner = (item: any, index: number) => {
  //   setCurrentTabPartner(item.key);
  //   swiper.slideTo(index, 1000, false);
  // };

  const openNewTabPage = (url: string) => {
    window.open(url, '_blank');
  };

  const immediateAccess = () => {
    report('click immediateAccess btn', 'product page');
    openNewTabPage('https://cloud.tencent.com/product/tmt');
  };

  const toDownLoad = () => {
    // 滚动到页面底部
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    <div className='page-product'>
      <div className='product-introduce'>
        <video muted loop autoPlay preload='auto'>
          <source src={translateAnimationVideo} type="video/mp4"/>
          Your browser does not support the video tag.
        </video>
        <img className='animation-person' src={animationPerson} alt=""/>
        <div className='product-introduce-animation'>
          <div className='introduce-content'>
            <div className='container'>
              <div className='introduce-detail'>
                <div className='name'>腾讯翻译君</div>
                <div className='target'>跨越语言，连接世界</div>
                <div className='detail'>
                  腾讯翻译君基于百亿级数据积累和领先算法，向用户提翻译服务，覆盖各类翻译场景。同时，我们也提供翻译小程序、翻译app等产品，帮助用户方便、快捷地体验翻译能力。
                </div>
                <div className='option'>
                  {/* <button type='button' className='primary' onClick={() => immediateAccess()}>立即接入</button> */}
                  <button type='button' className='primary' onClick={toDownLoad}>立即下载</button>
                </div>
              </div>
            </div>
          </div>
          <div className='sub-product-list'>
            <ul
              ref={subProductListRef}
              className='sub-product-card-list'
            >
              {
                ProductAbilityInfoCardList.map((item, index) => {
                  return <li key={index}>
                    <div className={`title ${item?.iconClassName}`}>{item?.title}</div>
                    <div className='detail'>{item?.detail}</div>
                  </li>;
                })
              }
            </ul>
            {/* <div className='card-circle-box'>
              <div className='container'>
                <ul className='card-circle'>
                  {
                    ProductAbilityInfoCardList.map((item, index) => {
                      return item && currentCardIndex !== -1 ? <li key={index} className={`card-circle-list ${currentCardIndex === index ? 'active' : ''}`}/> : null;
                    })
                  }
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className='other-product-introduce'>
        <div className='application-scenario'>
          <div className='container'>
            <div className='section-header'>应用场景</div>
            {/* <div className='section-subheading'>为不同需求的个人用户和各行各业的企业客户提供全面的翻译解决方案</div> */}
            <ul>
              {
                ApplicationScenarioInfoList.map((item, index) => {
                  return <li key={index}>
                    <img src={item?.img}/>
                    <div className='text'>
                      <div className='title'>{item?.title}</div>
                      <div className='detail'>{item?.detail}</div>
                    </div>
                  </li>;
                })
              }
            </ul>
          </div>
        </div>
        <div className='content-bottom'>
          <div className='container'>
            <div className='content-detail'>
              <div className='content-left'>
                <div className='list-item'>
                  <div className='title'>产品服务</div>
                  <ul>
                    <li>
                      <Link to="/" target="_blank">在线翻译</Link>
                    </li>
                  </ul>
                </div>
                <div className='list-item'>
                  <div className='title'>联系我们</div>
                  <ul>
                    <li>translate@tencent.com</li>
                    <li>腾讯云计算（北京）有限责任公司</li>
                  </ul>
                </div>
              </div>
              <div className='content-right'>
                {qrcodeList.map(item => (
                  <div key={item.id} className='qrcode-item'>
                    <img src={item.src} />
                    <p>{item.text}</p>
                  </div>
                ))}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
